import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { RegisterComponent } from "./pages/register/register.component";
import { RequestPasswordComponent } from "./pages/request-password/request-password.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { RequestPasswordSentComponent } from "./pages/request-password-sent/request-password-sent.component";
import { NotFoundComponent } from "./pages/not-found/not-found.component";
import { RequestVerifivationTokenComponent } from "./pages/request-verifivation-token/request-verifivation-token.component";
import { EmailVerifivationComponent } from "./pages/email-verifivation/email-verifivation.component";
import { TwoFactorAuthComponent } from "./pages/two-factor-auth/two-factor-auth.component";

const routes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  { path: "two-fact-auth", component: TwoFactorAuthComponent },
  { path: "register", component: RegisterComponent },
  { path: "request-password", component: RequestPasswordComponent },
  { path: "request-password/sent", component: RequestPasswordSentComponent },
  { path: "reset-password", component: ResetPasswordComponent },
  {
    path: "request-verification-token",
    component: RequestVerifivationTokenComponent,
  },
  { path: "email-verification", component: EmailVerifivationComponent },
  { path: "404", component: NotFoundComponent },
  {
    path: "dashboard",
    loadChildren: () =>
      import("src/app/dashboard/dashboard.module").then(
        (m) => m.DashboardModule
      ),
  },
  { path: "**", redirectTo: "404" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
